export function fetchActiveAlerts(apiUrl, accessToken) {
    return fetch(`${apiUrl}/v1/alerts/active`, {
        headers: {
            Authorization: `Bearer ${accessToken}`
        }
    });
}
